import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from 'material-ui/MenuItem';
import styled from 'styled-components';
import moment from 'moment';
import { objectToArray, sortArray, downloadCSV } from 'utils';
import { Trans, withTranslation } from 'react-i18next';

import SelectField from '../../../../app/components/selectField';
import ResultsTable from '../../../../app/components/resultsTable';
import TryAgain from '../../../../app/components/tryAgain';
import ActionMenu from '../../../../app/components/actionMenu';
import Header from '../../components/header';
import TableCheckbox from '../../components/tableCheckbox';

import ViewAttendee from './viewAttendees';
import { STAFF_ADMIN, HS_FEATURES_ENABLED_APPS } from '../../../../config';

import EventCalendarDisabledWrapper from '../eventCalendarDisabledWrapper';
import { CircularProgress } from '../../../../app/components/progress';
import themeStyles from '../../../../_export.scss';

const isCheckboxDisabled = (error, pending) => error && !pending;

let memberBodyFlag = false;

const SelectSection = styled.div`
  display: flex;

  & div {
    width: auto;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

class EventsAttendees extends Component {
  static propTypes = {
    pending: PropTypes.bool.isRequired,
    filteredChunks: PropTypes.object,
    error: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
    chunks: PropTypes.object,
    getEvents: PropTypes.func.isRequired,
    onGetEventFields: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func.isRequired,
    onSelectAllEventAttendees: PropTypes.func.isRequired,
    onDeselectAllEventAttendees: PropTypes.func.isRequired,
    selectMemberBody: PropTypes.func.isRequired,
    onDeleteSelected: PropTypes.func.isRequired,
    onFilterEventData: PropTypes.func.isRequired,
    onAddEventCalendarComponent: PropTypes.func,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    filter: PropTypes.string,
    profile: PropTypes.object.isRequired,
    fields: PropTypes.object,
    memberbody: PropTypes.string.isRequired,
    memberBodies: PropTypes.object,
    componentsPending: PropTypes.bool,
    eventComponentEnabled: PropTypes.bool,
    role: PropTypes.string,
    eventsList: PropTypes.object.isRequired,
    selectedEvent: PropTypes.string.isRequired,
    setSelectedEvent: PropTypes.func.isRequired,
    getEventAttendees: PropTypes.func.isRequired,
    eventOrganizer: PropTypes.string.isRequired,
    filterEventData: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    error: null,
    filter: '',
    chunks: {},
    filteredChunks: {},
    items: [],
    query: '',
    selected: [],
    selectAll: false,
    fields: {},
    memberbody: '',
    memberBodies: {},
  };

  componentDidMount() {
    memberBodyFlag =
      HS_FEATURES_ENABLED_APPS.indexOf(this.props.match.params.appname) > -1;
    //     this.props.selectMemberBody();
    //     this.props.getEvents();
    //     this.props.onGetEventFields();
  }

  getSelectAllCheckBox = () => {
    const {
      error,
      pending,
      chunks,
      selected,
      selectAll,
      onSelectAllEventAttendees,
      onDeselectAllEventAttendees,
      onDeleteSelected,
      t,
    } = this.props;
    return (
      <div style={{ display: 'flex' }}>
        <Checkbox
          checked={selectAll}
          onChange={(e, isChecked) =>
            isChecked
              ? onSelectAllEventAttendees()
              : onDeselectAllEventAttendees()
          }
          disabled={isCheckboxDisabled(error, pending)}
          style={{ marginLeft: -2, color: themeStyles.primaryColor }}
          disableRipple
        />
        <ActionMenu
          selected={selected}
          onDownloadSelected={() => {
            downloadCSV(this.getCsvData(selected, chunks), 'event-attendees');
          }}
          text={t('events')}
        />
      </div>
    );
  };

  getTitle = (selected, events) => (
    <span>
      <Trans>Events Attendees</Trans>:{' '}
      {selected.length
        ? `${selected.length} / ${Object.keys(events).length}`
        : Object.keys(events).length}
    </span>
  );

  getCsvData = (selected, chunks) => {
    const { t } = this.props;
    const csvColumns = [
      t('Full Name'),
      t('Email'),
      t('Message'),
      t('Type of User'),
      t('Event'),
      t('Date'),
    ];

    const head = `${csvColumns.join(',')}\n`;
    const data = objectToArray(chunks);

    const eventInfo = objectToArray(this.props.eventsList).filter(
      course => course.id === this.props.selectedEvent,
    );

    const body = data
      .filter(values => selected.includes(values.id))
      .map(item => {
        const details = {
          name: item.value.name,
          email: item.value.email,
          message: item.value.message,
          userType: item.value.userType,
          event: Object.values(eventInfo[0].value)[0],
          date: `${moment(new Date(item.value.created_at)).format(
            'DD/MM/YYYY',
          )}\n`,
        };
        return Object.values(details);
      })
      .join('');

    const table = head + body;
    return table;
  };

  suffixClass = this.props.items.length < 4 ? 'fix-left' : 'selected';

  getColumns = () => {
    const { t } = this.props;
    return [
      {
        id: 'name',
        header: t('Name'),
        classNames: 'col-xs-3',
      },
      {
        id: 'email',
        header: t('Email'),
        classNames: 'col-xs-3',
      },
      {
        id: 'userType',
        header: t('User Category'),
        classNames: 'col-xs-3',
      },

      {
        id: 'created_at',
        header: t('Date Registered'),
        classNames: 'col-xs-2',
        containerElement: ({ value }) => (
          <span>{value && moment(value).format('DD/MM/YYYY')}</span>
        ),
      },
      {
        id: 'selected',
        header: this.getSelectAllCheckBox(),
        classNames: `col-xs-1`,
        containerElement: ({ value, rowId }) => (
          <>
            <TableCheckbox
              value={value}
              onSelect={() => this.props.onSelect(rowId)}
            />
            <ActionMenu
              isItemOption
              selected={[rowId]}
              text={t('user')}
              onDownloadSelected={() => {
                downloadCSV(
                  this.getCsvData([rowId], this.props.chunks),
                  'event-attendees',
                );
              }}
            />
          </>
        ),
      },
    ];
  };
  render() {
    const {
      pending,
      items,
      error,
      getEvents,
      chunks,
      onFilterEventData,
      selected,
      history,
      match,
      profile,
      filteredChunks,
      memberbody,
      memberBodies,
      selectMemberBody,
      eventComponentEnabled,
      componentsPending,
      onAddEventCalendarComponent,
      role,
      eventsList,
      selectedEvent,
      setSelectedEvent,
      getEventAttendees,
      eventOrganizer,
      t,
      filterEventData,
    } = this.props;

    const isMemberBodies =
      profile.role === STAFF_ADMIN ? profile.memberBodies : true;

    const eventInstructions =
      Object.keys(eventsList).length === 0 ? (
        <p className="instructions-container">
          <p className="instructions-section-1">
            <Trans>
              Click on the '+' button to add a new event, complete the event
              fields and choose the preferred visibility settings.
            </Trans>
          </p>
          <p className="instructions-section-2">
            <span>
              <Trans>
                Please note: Events will be displayed in the page where Event
                Calendar is added.
              </Trans>
            </span>{' '}
            <span>
              <Trans>
                To add or delete fields in events simply go to the Event
                Calendar component.
              </Trans>
            </span>
          </p>
            
        </p>
      ) : null;
    const body = error ? (
      <TryAgain
        message={t('Oops, something went wrong...')}
        onRetry={() => getEvents()}
      />
    ) : (
      <ResultsTable
        items={items}
        chunks={filteredChunks}
        loading={pending}
        pending={pending}
        error={Object.keys(filteredChunks).length === 0 ? 'yes' : null}
        emptyMessage={
          selectedEvent
            ? t('Looks like there are no event attendees yet')
            : t(`Please select an event from above`)
        }
        optionalMessage={
          !memberBodyFlag && profile.role === STAFF_ADMIN
            ? null
            : eventInstructions
        }
        onRowTouchTap={event =>
          history.push(
            `/${match.params.appname}/members/events-attendees/${event}`,
          )
        }
        columns={this.getColumns('columns')}
      />
    );

    const content = (
      <section style={{ height: 'calc(100% - 168px)' }}>
        <Header
          {...this.props}
          title={this.getTitle(selected, chunks)}
          onChange={val => filterEventData(val)}
          // onSelectAllResponses={onSelectAllEvents}
          // onDeselectAllResponses={onDeselectAllEvents}
          // actionMenu={
          //   <ActionMenu
          //     selected={selected}
          //     onDeleteSelected={() => onDeleteSelected(selected, chunks)}
          //     text="events"
          //   />
          // }
          rightAfterSearch={
            profile.role !== STAFF_ADMIN ? (
              <SelectSection>
                <SelectField
                  style={{ width: '200px', marginTop: '-20px' }}
                  key="memberbody-filter"
                  options={sortArray(Object.entries(memberBodies), 'name').map(
                    option => (
                      <MenuItem
                        key={option[0]}
                        value={option[0]}
                        primaryText={option[1].name}
                      />
                    ),
                  )}
                  label={t('Select Event Organizer')}
                  value={eventOrganizer}
                  onChange={(i, payload) => {
                    selectMemberBody(payload);

                    getEvents();
                    //  onFilterEventData('', this.getColumns());
                  }}
                />
                {Object.keys(eventsList).length > 0 && (
                  <SelectField
                    style={{ width: '200px', marginTop: '-20px' }}
                    key="memberbody-filter"
                    options={objectToArray(eventsList).map(option => {
                      return (
                        <MenuItem
                          key={option.id}
                          value={option.id}
                          primaryText={Object.values(option.value)[0]}
                        />
                      );
                    })}
                    label={t('Select Event')}
                    value={selectedEvent}
                    onChange={(i, payload) => {
                      setSelectedEvent(payload);
                      getEventAttendees();
                      //  onFilterEventData('', this.getColumns());
                    }}
                  />
                )}
              </SelectSection>
            ) : null
          }
        />
        {body}
        <ViewAttendee />
      </section>
    );

    return !componentsPending ? (
      eventComponentEnabled ? (
        content
      ) : (
        <EventCalendarDisabledWrapper
          history={history}
          onAddEventCalendarComponent={onAddEventCalendarComponent}
          appname={match.params.appname}
          role={role}
        >
          {content}
        </EventCalendarDisabledWrapper>
      )
    ) : (
      <CircularProgress />
    );
  }
}

export default withTranslation()(EventsAttendees);
